import { ApiProfile, apiRoute }  from 'services/rest-util';

export module ReportModels {
  export class Report {
    public static ApiUrl: string = 'api/reports';

  }
}
